import Conditions from '../../../../../resources/conditions';
import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

export type Data = RaidbossData;

const triggerSet: TriggerSet<Data> = {
  id: 'KuganeOhashi',
  zoneId: ZoneId.KuganeOhashi,
  timelineFile: 'yojimbo.txt',
  triggers: [
    {
      id: 'Yojimbo Giga Jump',
      type: 'HeadMarker',
      netRegex: { id: '0057' },
      condition: Conditions.targetIsYou(),
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Run Marker Away',
          de: 'Mit Marker weglaufen',
          fr: 'Fuyez avec le marqueur',
          ja: 'マーカーから離れる',
          cn: '远离人群',
          ko: '징 멀리 떨어뜨리기',
          tc: '遠離人群',
        },
      },
    },
    {
      id: 'Yojimbo Dorito',
      type: 'HeadMarker',
      netRegex: { id: '0037' },
      condition: Conditions.targetIsYou(),
      response: Responses.doritoStack(),
    },
    {
      id: 'Yojimbo Gekko',
      type: 'HeadMarker',
      netRegex: { id: '0090' },
      condition: Conditions.targetIsYou(),
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Gekko Marker',
          de: 'Gekko Marker',
          fr: 'Marqueur Gekkô',
          ja: '月光マーキング',
          cn: '月光点名',
          ko: '월광 징',
          tc: '月光點名',
        },
      },
    },
    {
      id: 'Yojimbo Enchain',
      type: 'HeadMarker',
      netRegex: { id: '0005' },
      condition: Conditions.targetIsYou(),
      response: Responses.getOut(),
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Electrogenetic Force': 'Elektro-Kraft',
        'Embodiment': 'Gilgamesch-Doppelgänger',
        'Gilgamesh': 'Gilgamesch',
        'Inoshikacho': 'Ino-shika-cho',
        'Yojimbo': 'Yojinbo',
      },
      'replaceText': {
        'A Giant Me': 'Dann wirf mal \'nen Blick hinter uns!',
        'Ame-no-Murakumo': 'Ame no Murakumo',
        'Bitter End': 'Klingenschimmer',
        'Dragon Night': 'Drachennacht',
        'Dragon\'s Lair': 'Drachenhort',
        'Electrogenetic Force': 'Elektro-Kraft',
        'Enchain': 'Fesseln',
        'Epic Stormsplitter': 'Fließende Welt',
        'Gekko': 'Gekko',
        'Giga Jump': 'Giga-Sprung',
        'Hell\'s Gate': 'Höllentor',
        'Inoshikacho': 'Ino-shika-cho',
        'Kasha': 'Kasha',
        'Masamune': 'Masamune',
        'Metta-giri': 'Metta-giri',
        'Tiny Song': 'Liliputlied',
        'Unveiling': 'Enthüllung',
        'Wakizashi': 'Wakizashi',
        'Yukikaze': 'Yukikaze',
        'Zanma Zanmai': 'Zanma-zanmai',
      },
    },
    {
      'locale': 'fr',
      'replaceSync': {
        'Electrogenetic Force': 'Force électrogénétique',
        'Embodiment': 'double de Gilgamesh',
        'Gilgamesh': 'Gilgamesh',
        'Inoshikacho': 'Ino-shika-cho',
        'Yojimbo': 'Yojimbo',
      },
      'replaceText': {
        'A Giant Me': 'J\'ai toujours eu la folie des grandeurs',
        'Ame-no-Murakumo': 'Ame no Murakumo',
        'Bitter End': 'Éradication',
        'Dragon Night': 'Nuit du dragon',
        'Dragon\'s Lair': 'Fléau du dragon',
        'Electrogenetic Force': 'Force électrogénétique',
        'Enchain': 'Garrotage',
        'Epic Stormsplitter': 'Monde flottant',
        'Gekko': 'Gekkô',
        'Giga Jump': 'Giga saut',
        'Hell\'s Gate': 'Portes de l\'enfer',
        'Inoshikacho': 'Ino-shika-cho',
        'Kasha': 'Kasha',
        'Masamune': 'Masamune',
        'Metta-giri': 'Metta-giri',
        'Tiny Song': 'Air lilliputien',
        'Unveiling': 'Dévoilement',
        'Wakizashi': 'Wakizashi',
        'Yukikaze': 'Yukikaze',
        'Zanma Zanmai': 'Zanma zanmai',
      },
    },
    {
      'locale': 'ja',
      'replaceSync': {
        'Electrogenetic Force': '電撃',
        'Embodiment': 'ギルガメッシュの分身',
        'Gilgamesh': 'ギルガメッシュ',
        'Inoshikacho': '猪鹿蝶',
        'Yojimbo': 'ヨウジンボウ',
      },
      'replaceText': {
        'A Giant Me': '巨身の術',
        'Ame-no-Murakumo': 'アメノムラクモ',
        'Bitter End': 'ヒット・ジ・エンド',
        'Dragon Night': '竜星撃',
        'Dragon\'s Lair': '雲蒸竜変',
        'Electrogenetic Force': '電撃',
        'Enchain': '大捕物',
        'Epic Stormsplitter': '我流海嵐斬',
        'Gekko': '月光',
        'Giga Jump': 'ギガジャンプ',
        'Hell\'s Gate': '獄門',
        'Inoshikacho': '猪鹿蝶',
        'Kasha': '花車',
        'Masamune': 'マサムネ',
        'Metta-giri': '居合滅多斬り',
        'Tiny Song': '小さなメロディ',
        'Unveiling': '真ギルガメッシュチェンジ',
        'Wakizashi': '脇差',
        'Yukikaze': '雪風',
        'Zanma Zanmai': '斬魔三昧',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Electrogenetic Force': '电击',
        'Embodiment': '吉尔伽美什的分身',
        'Gilgamesh': '吉尔伽美什',
        'Inoshikacho': '猪鹿蝶',
        'Yojimbo': '保镖',
      },
      'replaceText': {
        'A Giant Me': '巨大化之术',
        'Ame-no-Murakumo': '天之丛云',
        'Bitter End': '命尽于此',
        'Dragon Night': '龙星击',
        'Dragon\'s Lair': '云蒸龙变',
        'Electrogenetic Force': '电击',
        'Enchain': '捕获',
        'Epic Stormsplitter': '我流破浪斩',
        'Gekko': '月光',
        'Giga Jump': '十亿跳跃',
        'Hell\'s Gate': '狱门',
        'Inoshikacho': '猪鹿蝶',
        'Kasha': '花车',
        'Masamune': '正宗',
        'Metta-giri': '居合多段斩',
        'Tiny Song': '缩小旋律',
        'Unveiling': '显露原形',
        'Wakizashi': '腰刀',
        'Yukikaze': '雪风',
        'Zanma Zanmai': '斩魔三昧',
      },
    },
    {
      'locale': 'tc',
      'replaceSync': {
        'Electrogenetic Force': '電擊',
        'Embodiment': '吉爾伽美什的分身',
        'Gilgamesh': '吉爾伽美什',
        'Inoshikacho': '豬鹿蝶',
        'Yojimbo': '保鑣',
      },
      'replaceText': {
        'A Giant Me': '月光',
        'Ame-no-Murakumo': '天之叢雲',
        'Bitter End': '命盡於此',
        'Dragon Night': '龍星擊',
        'Dragon\'s Lair': '雲蒸龍變',
        'Electrogenetic Force': '電擊',
        'Enchain': '捕獲',
        'Epic Stormsplitter': '我流破浪斬',
        'Gekko': '月光',
        'Giga Jump': '●分身出現',
        'Hell\'s Gate': '獄門',
        'Inoshikacho': '豬鹿蝶',
        'Kasha': '花車',
        'Masamune': '正宗',
        'Metta-giri': '居合多段斬',
        'Tiny Song': '縮小旋律',
        'Unveiling': '顯露原形',
        'Wakizashi': '腰刀',
        'Yukikaze': '雪風',
        'Zanma Zanmai': '斬魔三昧',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Electrogenetic Force': '전류',
        'Embodiment': '길가메시의 분신',
        'Gilgamesh': '길가메시',
        'Inoshikacho': '멧돼지사슴나비',
        'Yojimbo': '요우진보',
      },
      'replaceText': {
        'A Giant Me': '거대 길가메시',
        'Ame-no-Murakumo': '아메노무라쿠모',
        'Bitter End': '끝장타',
        'Dragon Night': '용성격',
        'Dragon\'s Lair': '운증용변',
        'Electrogenetic Force': '전류',
        'Enchain': '사슬 묶기',
        'Epic Stormsplitter': '아류해풍참',
        'Gekko': '월광',
        'Giga Jump': '기가 점프',
        'Hell\'s Gate': '지옥문',
        'Inoshikacho': '멧돼지사슴나비',
        'Kasha': '화차',
        'Masamune': '마사무네',
        'Metta-giri': '거합 마구베기',
        'Tiny Song': '작은 멜로디',
        'Unveiling': '진 길가메시 변신',
        'Wakizashi': '소도',
        'Yukikaze': '설풍',
        'Zanma Zanmai': '참마삼매',
      },
    },
  ],
};

export default triggerSet;
